import { useReduxSelector } from 'shared/hooks/useReduxSelector';
import { coworkingOperatorPhoneSelector } from 'shared/store/coworking/selectors/dump/coworkingOperatorPhoneSelector';

export function useCoworkingOperatorPhoneSelector(): string | null {
  return useReduxSelector<string | null>(coworkingOperatorPhoneSelector);
}
